/**
 * Copyright (c) eventlint. All Rights Reserved.
 *
 *
 * @summary
 * @author Segev {CJ} Shmueli <cj@segevs.com>
 *
 * Created: 7/1/2022
 */

import { Button, TextField, Typography } from '@mui/material';
import React from 'react';
import { useAuth } from '../hooks/AuthLogin';
import '../styles/login.scss';

const LoginComponent = () => {
    const [hasError, setHasError] = React.useState<boolean>(false);
    const [code, setCode] = React.useState<string>('');
    const auth = useAuth();

    const handleChange = (e: any) => {
        setHasError(false);
        setCode(e.target.value);
    }

    const handleClick = () => {
        auth.login(code).catch((err: any) => {
            setHasError(true);
        });
    }

    return (
        <div className="login-wrapper">
            <Typography variant='h1'>Welcome</Typography>
            <div className='py-8'>
                <TextField
                    disabled={auth.authenticating}
                    variant='outlined'
                    label="Access code"
                    helperText={hasError ? "Invalid access code" : ""}
                    error={hasError}
                    onChange={handleChange} value={code} />
            </div>
            <div>
                <Button variant='contained' onClick={handleClick} disabled={auth.authenticating}>{auth.authenticating ? 'Processing...' : 'Login'}</Button>
            </div>
        </div>
    );
}

export default LoginComponent;